// BRK-S319 — a missing required field is marked ON the field, not only listed.
//
// Daniel's walk (week of 10/4): a missing date of birth on the primary
// indemnitor surfaced as "Please complete: Date of birth" while he was on the
// spouse form, beside the spouse's own (optional) date of birth — and read as
// the spouse's. So every missing field now carries its own inline message
// (red border and label, `aria-invalid`, `aria-describedby`), through the same
// `invalid` channel a bad value and a server refusal already use, and the
// summary names where each one is.
import type { BondRenderField } from "@/lib/bondFields";

/** The inline message under a required field left blank. */
export function requiredMessage(label: string): string {
  return `${label} is required.`;
}

/**
 * The inline errors to RENDER: every missing field's "is required", under
 * whatever more specific reason a field already carries — a format rule or a
 * server refusal says more than "required" does, so it wins.
 */
export function withMissingInline(
  invalid: Readonly<Record<string, string>>,
  missing: readonly BondRenderField[],
): Record<string, string> {
  return {
    ...Object.fromEntries(
      missing.map((field) => [field.name, requiredMessage(field.label)]),
    ),
    ...invalid,
  };
}
